<!--  ******************************************************  -->
<!--  ADD or UPDATE CUSTOMER DIALOG                           -->
<!--    - Allows the customerUser to insert or update a Customer      -->
<!--  ******************************************************  -->
<mat-toolbar class="dialogToolbar">
  <h2 mat-dialog-title fxFlex>
    {{'PRODUCTITEM.TOKEN' | translate}}
  </h2>
  <button mat-icon-button color="accent" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="mat-typography dialogBody">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <mat-form-field fxFlex class="fullWidthField ">
      <mat-label>{{'PRODUCTITEM.TOKEN' | translate}}</mat-label>
      <input matInput required #productItemToken="ngModel" type="text" name="productItemToken"
             [(ngModel)]="newToken">
      <mat-error *ngIf="productItemToken.invalid">
        {{'PRODUCTITEM.TOKEN_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
      </mat-error>
    </mat-form-field>
    <button  *ngIf="newToken === data.token" mat-icon-button color="primary" [cdkCopyToClipboard]="data.token" [title]="'PRODUCTITEM.COPY_TOKEN' | translate" (click)="copiedToken()"><mat-icon>file_copy</mat-icon></button>
    <button *ngIf="newToken !== data.token" mat-icon-button color="primary" [title]="'PRODUCTITEM.RESET_TOKEN' | translate" (click)="newToken = data.token"><mat-icon>reply</mat-icon></button>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end" class="dialogFooter">
  <button mat-button [mat-dialog-close]="null">{{'BUTTONS.CLOSE' | translate}}</button>
  <button mat-button class="primaryButton" [disabled]="productItemToken.invalid || newToken === data.token" (click)="changeProductItemToken()">{{'BUTTONS.SAVE' | translate}}</button>
</mat-dialog-actions>

